import { inject } from '@angular/core';
import { CanActivateChildFn, CanActivateFn, Router } from '@angular/router';
import { AuthService } from 'app/core/auth/auth.service';
import { UserService } from 'app/core/user/user.service';
import { map, switchMap, take } from 'rxjs';

export const AdminGuard: CanActivateFn | CanActivateChildFn = (route, state) => {
    const router: Router = inject(Router);
    const authService = inject(AuthService);
    const userService = inject(UserService);

    // First check if user is authenticated
    return authService.check().pipe(
        switchMap((authenticated) => {
            if (!authenticated) {
                // Redirect to sign-in if not authenticated
                const redirectURL = `redirectURL=${state.url}`;
                const urlTree = router.parseUrl(`sign-in?${redirectURL}`);
                return [urlTree];
            }

            // Check if user has admin role
            return userService.user$.pipe(
                take(1),
                map((user) => {
                    if (user?.roles && user.roles.includes('admin')) {
                        // Allow access for admin users
                        return true;
                    }

                    // Redirect non-admin users to chat page
                    console.warn('Access denied: Admin role required', {
                        user: user?.username,
                        roles: user?.roles
                    });
                    return router.parseUrl('/chat');
                })
            );
        })
    );
};
